import React, { useRef } from 'react';
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import prevArrow from "../../images/icons/prev-icon.png"
import nextArrow from "../../images/icons/next-icon.png"

import "./slider.css"

const SliderSlick = ({ gallery }) => {
    const sliderRef = useRef(null)
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    return (
        <div className='carousel-container'>
            <Slider {...settings} ref={sliderRef}>
                {gallery.map((item, index) => (
                    <div key={index} className='carousel-slide'>
                        <img src={item} alt={`Carousel Media ${index}`}/>
                    </div>
                ))}
            </Slider>
            <div className='custom-arrow'>
                <button onClick={() => sliderRef.current.slickPrev()}><img src={prevArrow} alt="Previous" /></button>
                <button onClick={() => sliderRef.current.slickNext()}><img src={nextArrow} alt="Next" /></button>
            </div>
        </div>
    );
};

export default SliderSlick;